import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { DecreaseOriginalValueMain } from './DecreaseOriginalValueMain'
import { DecreaseOriginalValueForm } from './DecreaseOriginalValueForm/DecreaseOriginalValueForm'
import { DecreaseOriginalValueDetail } from './DecreaseOriginalValueDetail/DecreaseOriginalValueDetail'

const decreaseOriginalValueRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/decrease-original-value/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/decrease-original-value',
    },
    component: <DecreaseOriginalValueMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/decrease-original-value/add',
    },
    component: (
      <DecreaseOriginalValueForm formMode="add" type="ASSETS_REGISTRATION" />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/decrease-original-value/edit',
    },
    component: <DecreaseOriginalValueForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/decrease-original-value/resubmit',
    },
    component: <DecreaseOriginalValueForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/decrease-original-value/detail',
    },
    component: <DecreaseOriginalValueDetail />,
  },
]

export default decreaseOriginalValueRoutes
